<template>
  <b-modal
    :id="modalId"
    size="md"
    centered
    :hide-header="true"
    :hide-footer="true"
    content-class="p-2 atm-rounded"
    no-close-on-backdrop
  >
    <h3 class="mb-3">{{ title }}</h3>
    <div class="px-3">
      <div class="mb-4">
        <slot></slot>
      </div>
      <div class="d-flex gap-4 justify-content-center align-items-center ">
        <button
          class="atm-button flex-grow-1 bg-gray text-dark font-weight-bold w-50"
          @click="hideModal"
        >
          Cancel
        </button>
        <button class="atm-button flex-grow-1 bg-main font-weight-bold w-50 " @click="successAction">
          Confirm
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalId: { type: String, default: 'confirmModal' },
    title: { type: String, default: '' },
    confirmButton: { type: Function, default: () => {} },
    autoHideModal: { type: Boolean, default: true },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide(this.modalId);
    },
    successAction() {
      this.confirmButton();
      if (this.autoHideModal) this.hideModal();
    },
  },
};
</script>
